import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { IFilterOption } from '@common-types';
import './style.scss';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';

interface IProps extends WrappedComponentProps {
  title: string;
  titleInformation?: string;
  options: IFilterOption[];
  values: string[];
  onChange: (selectedValues: any[]) => void;
  disabled?: boolean;
  withShowMore?: boolean;
  displayZero?: boolean;
}

interface IState {
  shownMore: boolean;
}

const zero = 0;
const defaultOptionsCount = 5;

export class FilterCheckboxComponent extends React.Component<IProps, IState> {
  state: IState = {
    shownMore: false,
  };

  toggleOptions = (): void => {
    this.setState((prevState: IState) => ({
      shownMore: !prevState.shownMore,
    }));
  };

  render(): React.ReactNode {
    const { shownMore } = this.state;
    const { displayZero, title, titleInformation, options, values, onChange, disabled = false, withShowMore = false } = this.props;
    const showShowMore = withShowMore && options.length > defaultOptionsCount && !disabled;
    const resOptions = showShowMore
      ? shownMore
        ? options
        : options.slice(zero, defaultOptionsCount)
      : options;

    return (
      <div className="filter filter-checkbox">
        {!isEmpty(title) ? (
          <p className="filter__title secondary-font">
            <FormattedMessage id={title} />
            {!isEmpty(titleInformation) ? (
              <Tooltip title={this.props.intl.formatMessage({ id: titleInformation })} placement="top">
                <FontAwesomeIcon icon={faInfoCircle} />
              </Tooltip>) : null}
          </p>) : null}
        <Checkbox.Group value={values} onChange={onChange} disabled={disabled}>
          {resOptions?.map((item: IFilterOption) => {
            if (!item.count && !displayZero) {
              return null;
            }

            const count = item.count ? item.count : 0;
            return (
              <div key={item.value}>
                <Checkbox value={item.value} disabled={disabled}>
                  <span className="filter__option-name">{item.label}</span>
                  {count > zero ? (
                    <span className="filter__option-quantity">{item.count}</span>
                  ) : null}
                </Checkbox>
              </div>
            );
          })}
        </Checkbox.Group>
        {showShowMore ? (
          <div className="filter__show-link" onClick={this.toggleOptions}>
            {shownMore ? <FormattedMessage id="show.less" /> : <FormattedMessage id="show.more" />}
          </div>
        ) : null}
      </div>
    );
  }
}


export const FilterCheckbox = connect()(injectIntl(FilterCheckboxComponent));
